import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../../app/app.service';
import { FormGroupedByCategoryVM } from '../entities/global/model';
import { Form, FormCategory, FormsVM } from '../perform-induction/perform-induction';
import { SafetyFormsService } from '../services/safety-forms.service';
import { SafetyInductionService } from '../services/safety-induction.service';

@Component({
  selector: 'app-select-a-form',
  templateUrl: './select-a-form.component.html',
  styleUrls: ['./select-a-form.component.css']
})
export class SelectAFormComponent implements OnInit {

  constructor( private _router:Router,private _app: AppService,private _inductionService: SafetyInductionService,
    private SafetyFormsService_:SafetyFormsService,) { }

  //  groupedForms:FormGroupedByCategoryVM[]
    formCategories:FormCategory[]
    FormsVM_:FormsVM
    forms:Form[]
  ngOnInit() {
   
    this.GetDataForForms();
    this._app.setPageTitle('Select Form');
  }

  
  NavigateToUploadDigitalFormsComponent(FormID:number){
    this._router.navigate(['/uploaddigitalformscomponent',FormID]);

  }

  DownloadForm(FormID:number,FileName:string){
 
      this._inductionService.GetFormFileDataForNew(FormID).subscribe(msg=>{
        var newstring = msg.slice(1);
                      console.log('length ', newstring.length - 1)
   
                      let _newstring = newstring.substring(0, newstring.length - 1);
   
                    //  console.log("newstringnewstringnewstring", _newstring)
   
                      var arrBuffer = this.base64ToArrayBuffer(msg);
          
                      var blob = new Blob([arrBuffer], { type: 'application/pdf' });
                      //const linkSource = `data:application/pdf;base64,${msg}`;
                       var link = document.createElement('a');
                       //const fileName = "vct_illustration.pdf";
   
                       link.href = window.URL.createObjectURL(blob);
                      // link.download = FileName+ '.pdf';

                       window.open(link.href, '_blank');
                    //  link.click();
      })
    
  }

  base64ToArrayBuffer(base64) {
    console.log("base64", base64)
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
  
  // CreateNewInspection()
  // {
  //   let model = new ObservationDetailsDomain()
  //   model.ObservationDate=this.observationDate
  //   model.WorkAreaID=this.inputValueWorkArea
  //   model.TaskObserved=this.inputValueTaskObserved
  //   model.SiteId=this.inputValuestate
  //   this._safetyGeneraldashboardService.CreateNewInspection(model).subscribe(res=>
  //     {
  //       console.log(res)
  //       if(res>0){
  //         //this.router.navigateByUrl('Inspection/Index',res);
  //         this.router.navigate(['/Inspection/Index', res]);
  //         this.DialogClose();
  //       }
        
  //     });

      
     
  // }

GetDataForForms()
{
  this.SafetyFormsService_.GetDataForForms().subscribe(res =>{ 
    this.FormsVM_=res.m_Item2
    this.formCategories= this.FormsVM_.Categories
    this.forms=this.FormsVM_.Forms
    
    console.log("frm categories with pdf",res)
  })
}

}
